import { mount } from "./cpq-app";
import {
  isBrowserIframeChild,
  runCpqPostMessageIframeHostFlow,
} from "./cpq-iframe-embed-host";

function showError(message: string): void {
  document.body.insertAdjacentHTML(
    "afterbegin",
    `<p style="color:#b00;padding:1rem">${message}</p>`
  );
}

/** `#player-shell` wraps `#player` in `index.html` and is already `position: relative`. */
const DOCK_MOUNT_OPTIONS = { animationDockShell: "#player-shell" };

if (isBrowserIframeChild()) {
  runCpqPostMessageIframeHostFlow("#player", undefined, DOCK_MOUNT_OPTIONS);
} else {
  mount("#player", DOCK_MOUNT_OPTIONS)
    .then((handle) => {
      (window as unknown as { threekitCpq: typeof handle }).threekitCpq = handle;
      if (import.meta.env.DEV) {
        console.info(
          "Threekit CPQ: window.threekitCpq — setConfiguration, optionsShow, optionInteraction, custom"
        );
      }
    })
    .catch((err: unknown) => {
      console.error(err);
      const msg =
        err instanceof Error
          ? err.message
          : "Failed to start Threekit CPQ embed.";
      showError(msg);
    });
}
